import axios from "axios";
import { ListQueryParams } from "@/models/table";
import { StockInsidersBasics, StockInsidersFlag } from "@/models/stock-insiders";

// #2098: the grids below now read /interface/api/insiders/, which is served
// from ORTEX's own EDGAR, SEDI and global-venue tables rather than the 2iQ
// feed. Instruments are addressed by ortex_tid where the caller has it and
// tradingitem_id otherwise; neither endpoint takes a ticker, because tickers
// repeat across venues.
const INSIDERS_API = "/interface/api/insiders";

const stockListFetcher = (path: string) => async (params: ListQueryParams) => {
    const { page_size, page, filter_options, signal, next_page_url, universe_id, data } = params;
    // DataGrid passes the instrument through `id`, which it names
    // `universe_id` on the way in.
    const url = next_page_url || `${INSIDERS_API}/${path}`;
    const defaultParams = next_page_url ? {} : { page_size, page, tradingitem_id: universe_id, ...filter_options, ...data };

    const res = await axios.get(url, { params: { ...defaultParams }, signal });
    return res.data;
};

export const getStockInsidersBasics = async (id: number) => {
    const res = await axios.get<StockInsidersBasics>(`/API/v2/id/${id}/insiders/basics`);

    return res.data;
};

/** Each insider's latest stated position in this instrument. */
export const getStockInsidersPositions = stockListFetcher("positions/list");

/** The people who file at this instrument, each linking to their own page. */
export const getStockInsiderPeople = stockListFetcher("stock/people/list");

/** This instrument's insider dealings, every market, from our own tables. */
export const getStockInsidersTransactions = stockListFetcher("transactions/list");

export const getStockInsidersFlags = async (stock: number, from: string, to: string) => {
    const res = await axios.get<{ [key: string]: boolean | [number, number][] | StockInsidersFlag[]; obfuscated?: boolean; ts_shortened?: boolean }>("/API/insider_ts/", {
        params: {
            stock,
            from,
            to,
        },
    });

    return res.data;
};
